<!--模板导入 页面-->
<template>
  <div class="gray-back">
    <!--    <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">-->
    <!--      <van-tab title="正常"></van-tab>-->
    <!--      <van-tab title="隐藏"></van-tab>-->
    <!--    </van-tabs>-->
    <!--    <div class="box yundongyuan-box">-->
    <!--      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">-->
    <!--        <van-list-->
    <!--            v-model="loading"-->
    <!--            :finished="finished"-->
    <!--            finished-text="没有更多了"-->
    <!--            @load="onLoad"-->
    <!--        >-->
    <!--          <div class="kaojicenter-list-box">-->
    <!--            <div class="kaojicenter-lists flex-between" v-for="(item, index) in list"-->
    <!--                 @click="action(item, index)">-->
    <!--              <div class="kaojicenter-rights">-->
    <!--                <div class="title">{{ item.name }}</div>-->
    <!--                <div class="desc flex-start">-->
    <!--                  <van-tag round v-if="item.cert_status==1" type="success">已认证</van-tag>-->
    <!--                  <van-tag round v-else-if="item.cert_status==3">认证失败</van-tag>-->
    <!--                  <van-tag round v-else-if="item.cardtype==1 && item.cert_status==2" type="warning">未认证</van-tag>-->
    <!--                  <van-tag round plain v-else-if="item.cardtype!=1 && item.cert_status==2">无需认证</van-tag> &nbsp;-->
    <!--                  {{ item.num }}-->
    <!--                </div>-->
    <!--              </div>-->
    <!--            </div>-->
    <!--          </div>-->
    <!--        </van-list>-->
    <!--      </van-pull-refresh>-->

    <van-action-sheet v-model="actionShow" :actions="actions" @select="onActionSelect"/>

    <div class="savebtn">
      <van-button
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="width: 3rem"
          size="normal"  @click="download" round>模板下载
      </van-button>
      <van-uploader
          accept=".xls,.xlsx"
          :after-read="readFile"
      >
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round>导入模板
        </van-button>
      </van-uploader>

    </div>
    <van-popup :close-on-click-overlay="false" v-model="showLoading">
      <div class="circle-div">
        <van-circle :stroke-width="60" :color="{
                                '0%': '#ffad19',
                                '100%': '#fec835',
                              }" v-model="progress" :rate="progress" :speed="100" :text="progress+'%'"/>
        <van-button
            style="width: 3rem; margin-top: 10px"
            size="normal" round>上传中
        </van-button>
      </div>
      <div>
      </div>

    </van-popup>

    <van-dialog v-model="showError" title="批量导入错误信息">
      <van-cell-group>
        <van-cell :title="item" v-for="item in errorMsg"/>
      </van-cell-group>
    </van-dialog>
  </div>
</template>
<style scoped>

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}

.box {
  /*margin-bottom: 50px;*/
  background: rgba(248, 248, 248, 1);
  min-height: 90vh;
}

.kaojicenter-list-box {
  padding-top: 0.2rem;
  /*background: rgba(248,248,248,1);*/
}

.goods-line {
  height: 55px;
}

.goods-bottom-line {
  width: 100%;
  position: fixed;
  height: 60px;
  bottom: 0;
  background: linear-gradient(180deg, hsla(255, 0%, 100%, 0), #fff);
}

.goods-create-btn {
  position: fixed;
  bottom: 10px;
  width: 100%;
  height: 44px;
  font-size: 16px;
  text-align: center;
}

.goods-create-btn button {
  width: 3.2rem;
}

.goods-create-btn img {
  width: 60px;
  height: 60px;
}

.goods-header {
  display: flex;
  justify-content: space-between;
  position: fixed;
  top: 0;
  z-index: 99;
  width: 100%;
  margin-bottom: 0.01rem;
  background: #fff;
}

.van-tabs {
  /*width: 85% !important;*/
}

.screen-btn {
  line-height: 44px;
  height: 44px;
}

.screen-btn img {
  width: 45%;
  padding-left: 15px;
  vertical-align: middle;
  border-left: 1px solid #D5D5D5;
}

.sidebar {
  padding-top: 15px;
}

.search-box img {
  width: 60px;
  height: 60px;
}


.select-btn {
  position: fixed;
  bottom: 0;
  width: 90%;
  margin: 0 auto;
  padding: 0px 15px 30px;
}

.btn-reset {
  padding-bottom: 10px;
}

.btn-reset >>> .van-button {
  background: #ddd;
}

.selected {
  color: #444;
}


.kaojicenter-lists {
  padding: 0.2rem;
  border-radius: 10px;
  background: #fff;
  margin: 0 0.2rem 0.2rem;
}

.kaojicenter-lefts {
  position: relative;
}


.kaojicenter-lefts .img {
  border-radius: 10px;
  width: 1rem;
  height: 1rem;
}

.kaojicenter-rights {
  width: calc(100% - 1.2rem);
  position: relative;
  height: 1rem;
}

.kaojicenter-rights .title {
  font-size: 15px;
  font-weight: bold;
}

.kaojicenter-rights .desc {
  font-size: 12px;
  padding-top: 10px;
  color: #999;
}

.yundongyuan-box >>> .van-popup {
  background: none;
}

.circle-div {
  text-align: center;
}

.circle-div >>> .van-circle__text {
  color: #fff !important;
}
</style>

<script>
import Vue from 'vue';
import validator from "../../../utils/validator";
import IdCardPicker from "../../../components/picker/IdCardPicker.vue";

import {
  Cell,
  CellGroup,
  Toast,
  Dialog,
  Icon,
  PullRefresh,
  List,
  Tag,
  Button,
  Progress,
  DropdownMenu,
  DropdownItem,
  DatetimePicker
} from 'vant';
import XLSX from "xlsx";

Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(Progress).use(DropdownMenu).use(DropdownItem).use(DatetimePicker);
export default {
  name: 'HuiyiApplyFormShare',
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    IdCardPicker
  },
  data: function () {
    return {
      validator,
      id: 0,
      active: 0,
      showDate: false,
      showError: false,
      showLoading: false,
      actionShow: false,
      addShow: false,
      list: [],
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2015, 0, 1),
      showNumTypePicker: false,
      numTypeColumns: ['身份证', '护照', '其他身份证明'],
      actions: [
        {name: '隐藏'},
        {name: '认证'},
      ],
      params: {
        user_id: 0,
        pageNo: 1,
        pageSize: 10,
        keywords: '',
        cate_id: 0,
        is_show: 1
      },
      formData: {
        name: '',
        num: '',
        danwei: '',
        phone: '',
        sex: '',
        weixin: '',
        csize: '',
        footsize: '',
        is_join_exame: 2,
      },
      formDataRs: {
        baoming_id: 0,
        user_id: 0,
        member_list: []
      },
      saveLoading: false,
      isLoading: false,
      loading: false,
      finished: false,


      listData: [],
      errorMsg: [], // 错误列表
      index: 0,
      progress: 0,
      startNum: 1,
    }
  },
  mounted() {
    document.title = "训练营运动员管理"
    let user_id = this.formDataRs.user_id = this.$route.query.user_id
    this.formDataRs.baoming_id = this.$route.query.baoming_id
    if (!user_id) {
      Toast.fail('请输入正确的链接')
      return
    }
  },
  computed: {},
  filters: {},
  destroyed() {
  },
  methods: {
    download() {
      console.log('donwload')
      let that = this;
      // 模板 动态生成
      window.open(window.root + '/api/huiyi/templateGene?id=' +that.formDataRs.baoming_id)
      return
      window.open('https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-21/1626854723732285.xlsx')
      return
      appEvent({
        name: 'downloadFile',
        query: {
          name: '考级人员信息导入表模板',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-16/1626404860889325.xlsx'
        }
      });
    },

    readFile(evt) {
      console.log('------readFile------', evt)
      var that = this;
      that.errorMsg = []
      that.index = 0

      let files = {0: evt.file}

      const fileReader = new FileReader();
      fileReader.onload = (ev) => {
        try {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {
            type: 'binary'
          });
          const wsname = workbook.SheetNames[0];//取第一张表
          var list = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);//生成json表格内容

          // if (that.startNum) {
          //   list = list.splice(that.startNum, list.length)
          // }

          that.listData = list
          // let listData = list.filter(row => {
          //   return row.hasOwnProperty("__EMPTY");
          // })
          console.log('onGetData', list)

          // todo 增加进度条显示 并上传数据

          that.formatData()

        } catch (e) {
          console.log(e)
          return false;
        }
      };
      fileReader.readAsBinaryString(files[0]);
    },

    formatData() {
      let that = this
      that.showLoading = true
      that.listData.map((row) => {
        that.addRow(row)
      })
    },

    addRow(row) {
      let that = this
      that.formData.name = row['姓名']
      that.formData.sex = row['性别']
      that.formData.phone = row['联系电话'] ? row['联系电话'] : ''
      that.formData.num = row['身份证号'] ? row['身份证号'] : ''
      that.formData.weixin = row['微信号'] ? row['微信号'] : ''
      that.formData.email = row['邮箱'] ? row['邮箱'] : ''
      that.formData.is_join_exame = row['是否参加能力测试(是/否)'] == "是" ? 1 : 2
      that.formData.join_exame_name = row['技术等级测试项目(技巧/花球/街舞/爵士)']
      that.formData.chengji = row['成绩']
      that.formData.service_id = 0
      that.formData.price = 0

      let jsonList = Object.keys(row),
          jsonData = {}
      jsonList.map((json, index) => {
        if(index >= 10) {
          console.log(json,index)
          jsonData[json] = row[json]
        }
      })
      that.formData.jsondata = jsonData
      // [{"label":"鞋码","desc":"请输入鞋码","required":true},{"label":"衣服尺寸","desc":"请输入衣服尺寸","required":false},{"label":"报名时间","desc":"请输入报名时间","required":false}]
      console.log(that.formData, Object.keys(row), jsonData)
      that.yundongyuanAdd()
    },

    yundongyuanAdd() {
      let that = this
      // 添加到member_list中

      that.formDataRs.member_list.push(that.formData)
      // that.getProgress()
      // that.onRefresh();
      that.formData = {
        name: '',
        num: '',
        danwei: '',
        phone: '',
        sex: '',
        weixin: '',
        jsondata: [],
        join_exame_name: '',
        is_join_exame: 2,
      };

      console.log(that.formDataRs)
      that.getProgress()

      return
      that.$api.post('/api/huiyi/memberSaveAll', that.formData, (res) => {

        that.getProgress()
        // that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          danwei: '',
          phone: '',
          sex: '',
          weixin: '',
          csize: '',
          footsize: '',
          is_join_exame: 2,
        };
      }, (res) => {
        if (res.code === 600) {
          that.errorMsg.push(res.msg)
        }
        that.getProgress()
      })
    },

    getProgress() {
      let that = this
      that.index += 1

      let index = that.index,
          list = that.listData

      console.log(that.errorMsg, index, list.length)

      that.progress = ((index / list.length) * 100).toFixed(0);
      if (index === list.length) {
        that.showLoading = false
        that.$api.post('/api/huiyi/memberSaveAll',
        {
          baoming_id:that.formDataRs.baoming_id,
          user_id:that.formDataRs.user_id,
          member_list:JSON.stringify(that.formDataRs.member_list),
        }
        , (res) => {
          that.formDataRs.member_list = []
          Toast.success('批量导入成功')
        }, (res) => {
          that.formDataRs.member_list = []
          if (res.code === 600) {
            that.errorMsg.push(res.msg)
            that.showError = true
          }
        })


      }
    },

    action(item, index) {
      return
      this.actionShow = true;
      this.params.id = item.id;
      this.params.name = item.name;
      this.actions = [];
      if (item.is_show == 1) {
        this.actions.push({name: '隐藏'});
      } else {
        this.actions.push({name: '显示'});
      }
      if (item.cert_status == 2) {
        this.actions.push({name: '认证'});
      } else {
      }

    },
    onActionSelect(action, index) {
//                console.log(action); return ;
      let that = this;
      switch (index) {
        case 0 :
          if (action.name == '隐藏') {
            Dialog.confirm({
              title: '确认',
              message: '是否隐藏该运动员?',
            })
                .then(() => {
                  // on confirm
                  that.$api.post('/api/yundongyuan/hide', {
                    id: that.params.id
                  }, (res) => {
                    that.onRefresh();
                  }, (res) => {
                    Toast.fail(res.msg);
                  })

                })
                .catch(() => {
                  // on cancel
                });
          } else {
            that.$api.post('/api/yundongyuan/show', {
              id: that.params.id
            }, (res) => {
              that.onRefresh();
            }, (res) => {
              Toast.fail(res.msg);
            })
          }

          this.actionShow = false;
          break;

        case 1 :
          //认证
          // on confirm
          that.$api.post('/api/yundongyuan/cert', {
            id: that.params.id
          }, (res) => {
            that.onRefresh();
          }, (res) => {
            Toast.fail(res.msg);
          })
          break;

        case 2 :


          break;

      }
      this.actionShow = false;
    },

    onRefresh() {
      let that = this;
      that.params.pageNo = 1;
      // that.getList();
    },

    onDateConfirm(date) {
      console.log('onDateConfirm', date);
      this.showDate = false;
      this.formData.birthday = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    submit() {

    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    onFamilyIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.jianhuname = data.name;
      this.formData.jianhunum = data.cardNum;
    },
    onIdSuccess(data) {
      console.log('onIdSuccess', data);
      this.formData.name = data.name;
      this.formData.num = data.cardNum;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;
      that.$api.post('/api/yundongyuan/add', that.formData, (res) => {
        that.saveLoading = false;
        that.addShow = false;
        that.onRefresh();
        that.formData = {
          name: '',
          num: '',
          huzhao: '',
          cardtype: 1,
          birthday: '',
          sex: 1,
          numTypeName: '身份证',
          jianhuname: '',
          jianhunum: '',
          jianhuphone: '',
        };
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },


    // 更改状态
    onStatusChange(index) {

      let that = this;
      that.params.is_show = index + 1;
      that.params.pageNo = 1;

      // 激活下拉
      that.finished = false;
      that.loading = true;
      that.list = [];

      this.$route.query.is_show = 0;
      that.getList()
    },


  }
}
</script>



// WEBPACK FOOTER //
// HuiyiApplyFormShare.vue?69683362